import * as React from 'react';
import { classNames } from '@core/utils/functions/class-names';

type SectionHeaderProps = {
    className?: string;
    title: string;
    link: string;
    target: string;
};

const SectionHeader = (props: SectionHeaderProps) => {
    const { title, link, className, target } = props;

    return (
        <a
            href={link}
            target={target}
            rel="noreferrer"
            className={classNames(
                'text-base text-left px-3 py-1.5 bg-primary text-white border border-transparent hover:border-primary hover:bg-white hover:text-primary',
                className
            )}
        >
            {title}
        </a>
    );
};

export default SectionHeader;
